import { render, staticRenderFns } from "./RsaPaiRuoliEditComponent.vue?vue&type=template&id=bf263078"
import script from "./RsaPaiRuoliEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPaiRuoliEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports